// This file is auto-generated.
// It's responsible for giving the view it's own Flow context.

import { Flow } from 'Simple/Flow'
import React from 'react'
import DataVaxiomProfessionalsRelationshipsList from './data'

export default function DataVaxiomProfessionalsRelationshipsListFlow({ children, ...props }) {
  return (
    <Flow viewPath={props.viewPath} flowDefinitionViewPathSource="/DesignSystem/DataVaxiomProfessionalsRelationshipsList">
      <DataVaxiomProfessionalsRelationshipsList {...props}>
        {children}
      </DataVaxiomProfessionalsRelationshipsList>
    </Flow>
  )
}
